type ComputeBetTypeSelectorPosition = {
  isFdr?: boolean;
  withVideo?: boolean;
  withFixedBanner?: boolean;
  betTypeSelectorOffset?: number;
  isLiveTv?: boolean;
  isLogged?: boolean;
  isAccountCompliant?: boolean;
};

const computeBetTypeSelectorPosition = ({
  isFdr = false,
  withVideo = false,
  withFixedBanner = false,
  betTypeSelectorOffset = 0,
  isLiveTv = false,
  isLogged = false,
  isAccountCompliant = false
}: ComputeBetTypeSelectorPosition) => {
  const headerHeight = 44;
  const bannerHeight = 34;
  const raceSelectorHeight = 56;
  const videoLoggedOutHeight = 236;

  const scrollbarWidth =
    typeof window !== "undefined"
      ? window.innerWidth - document.body.clientWidth
      : 0;

  if (isFdr) {
    if (isLiveTv && (!isLogged || !isAccountCompliant)) {
      return `${
        raceSelectorHeight +
        videoLoggedOutHeight +
        (isLogged && !isAccountCompliant ? bannerHeight : 0)
      }px`;
    }

    // 100vw does not consider the scrollbar width
    // This method allows us to calculate the top based on the height of the video.
    // to determine a height on 16:9 aspect ratio we need the formula (100%(width) * 9 / 16 )
    if (isLiveTv) {
      return `calc((100vw - ${scrollbarWidth}px) * 9 / 16 + ${raceSelectorHeight}px + ${
        withFixedBanner ? bannerHeight : 0
      }px)`;
    }

    if (!withVideo) {
      return !withFixedBanner
        ? `${headerHeight}px`
        : `${headerHeight + bannerHeight}px`;
    }

    return `calc(var(--hdr-height, ${headerHeight}px) + ${betTypeSelectorOffset}px + ${
      withFixedBanner ? bannerHeight : 0
    }px)`;
  }

  return `calc(var(--hdr-height, 76px) + ${headerHeight}px)`;
};

export default computeBetTypeSelectorPosition;
